import styled from "@emotion/styled"


export const BlockItemBooleanStyles = styled.div`
    margin-bottom: 20px;
`